import type { StorefrontAdapter } from '../types';
import { loadScriptOnce } from '../types';

/**
 * Mailchimp Connected Sites: the tracking script does its own page/product
 * tracking once loaded, so this adapter only injects it. Server-side sync
 * (carts, orders, customers) carries the commerce data.
 */
export const mailchimpAdapter: StorefrontAdapter = {
  id: 'mailchimp',
  isConfigured: (cfg) => typeof cfg.site_script_url === 'string' && /^https:\/\/[a-z0-9.-]*chimpstatic\.com\//i.test(cfg.site_script_url),
  load(cfg) {
    loadScriptOnce('mailchimp-connected-site', cfg.site_script_url);
  },
};
